var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"call-volume"},[_c('div',{staticClass:"volume-container",class:{ 'high-volume': _vm.highVolume }},[_c('div',{staticClass:"volume-level",style:({ width: _vm.percentage })})])])}
var staticRenderFns = []

export { render, staticRenderFns }